module.exports = __webpack_public_path__ + "static/media/top-line.610dcb1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/top-line.svg
// module id = 177
// module chunks = 0